import * as types from '../constants/idpAdminActions';
import {authApi} from "../api/api";

export const authStart = () => ({
  type: types.AUTH_START
});
export const authSuccess = (response) => ({
  type: types.AUTH_SUCCESS,
  response,
});
export const authFail = (errorMsg) => ({
  type: types.AUTH_FAIL,
  errorMsg,
});

export function auth(authToken, idpInstanceId, applianceUuid, capabilities) {
  return dispatch => {
    dispatch(authStart());
    return authApi(authToken, idpInstanceId, applianceUuid, capabilities)
    .then(response => {
      dispatch(authSuccess(response));
    })
    .catch((error) => {
      dispatch(authFail(error.message));
    });
  }
}

export const storeCapabilitiesConst = (mappedCapabilities) => ({
  type: types.STORE_CAPABILITIES,
  mappedCapabilities,
});

export function mapAndStoreCapabilities(capabilities) {
  let mappedCapabilities = Object.assign({},
      ...capabilities.map(object => ({[object.capabilityName]: true})));
  return dispatch => {
    dispatch(storeCapabilitiesConst(mappedCapabilities));
  }
}

export const storeExtendedAttributes = (extendedAttributes) => ({
  type: types.STORE_EXTENDED_ATTRIBUTES,
  extendedAttributes,
});

export function mapAndStoreExtendedAttributes(extendedAttributes) {
  return dispatch => {
    dispatch(storeExtendedAttributes(extendedAttributes));
  }
}
